import type { TvBundleInfo, TvBundleWithContent } from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { UiTvBundleInfo, UiTvBundleWithContent } from './index.h'

import {
  extendMediaItemByLabelPrice,
  extendMediaItemByLabelPriceTvChannel,
  getLabelPriceForPurchasedItem,
} from '~/shared/tools'

export const formatBundleWithContent = (
  bundle: TvBundleWithContent,
  adjustChannel: AdjustPurchaseableFn,
  adjustSet: AdjustPurchaseableFn,
  t: TFunction
): UiTvBundleWithContent => {
  const adjustedBundle = adjustSet(bundle)
  const { purchaseInfo, channels } = adjustedBundle

  const rentedDuration = getLabelPriceForPurchasedItem({ purchaseInfo })
  const labelRented = rentedDuration
    ? t('rented_to', {
        duration: rentedDuration,
      })
    : ''

  const channelsFormatted = adjustedBundle.purchaseInfo
    ? channels.map(adjustChannel)
    : channels.map((channel) =>
        extendMediaItemByLabelPriceTvChannel(adjustChannel(channel), true)
      )

  return {
    ...adjustedBundle,
    labelRented: labelRented,
    channels: channelsFormatted,
  }
}

export const formatTvBundleRowWithContent =
  (t: TFunction, adjust: AdjustPurchaseableFn) =>
  (bundle: TvBundleInfo): UiTvBundleInfo => {
    bundle = adjust(bundle)
    const { labelPrice, rented } = extendMediaItemByLabelPrice(bundle)
    return {
      ...bundle,
      labelPrice,
      rented,
      quantityText: t('live_channel_number', {
        count: bundle.contentQuantity,
      }),
      link: `/content/live/bundles/${bundle.id}`,
    }
  }
